export default __webpack_public_path__ + "static/media/add-button.0840967e.svg";